import React from 'react';
import { CtaButton } from './CtaButton';
interface PricingCardsProps {
  compact?: boolean;
}
export function PricingCards({
  compact = false
}: PricingCardsProps) {
  return <div className="grid gap-6 md:grid-cols-2" data-id="element-164" data-mp="21f4ijcut2of5">
      {/* Super Kit */}
      <div className="flex flex-col rounded-2xl border border-[var(--olive)]/50 bg-[#0d0f08] p-6 sm:p-8" data-id="element-165" data-mp="21h7esemjxdsb">
        <div className="mb-4 flex items-center gap-2" data-id="element-166" data-mp="26buubnzkuxur">
          <span aria-hidden="true" data-id="element-167" data-mp="2bc90t1lj5zqo">📘</span>
          <h3 className="font-serif-display text-2xl font-bold text-[var(--cream)]" data-id="element-168" data-mp="2bbhigsgy1yic">
            Super Kit S.O.S. Pilates
          </h3>
        </div>
        <p className="mb-6 text-sm text-white/60" data-id="element-169" data-mp="2k6nifatj9mcy">
          6 Tomos + 6 Bonos · Todo el año resuelto
        </p>
        <div className="mb-6 mt-auto" data-id="element-170" data-mp="2p3dza0d5wlzf">
          <p className="text-lg text-white/40 line-through" data-id="element-171" data-mp="2u3s5rdz47nvc">$51.000</p>
          <p className="font-serif-display text-4xl font-bold text-[var(--cream)] sm:text-5xl" data-id="element-172" data-mp="2u5mt0yxuzs2l">
            $19.990 <span className="text-xl text-[var(--gold)]" data-id="element-173" data-mp="2z34uk49jr50k">ARS</span>
          </p>
        </div>
        <CtaButton variant="olive" size={compact ? 'md' : 'lg'} data-id="element-174" data-mp="3ti7k154yk7wo">
          Quiero mi Super Kit
        </CtaButton>
      </div>

      {/* Super Kit + Estudio PRO */}
      <div className="relative flex flex-col rounded-2xl border-2 border-[var(--gold)] bg-[#12140b] p-6 shadow-[0_0_40px_-12px_rgba(203,163,92,0.4)] sm:p-8" data-id="element-175" data-mp="3jhyn1p356ig8">
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-[var(--gold)] px-4 py-1 text-xs font-extrabold uppercase tracking-wide text-black" data-id="element-176" data-mp="3fjhkliuo1w55">
          ⭐ Más elegido
        </span>
        <div className="mb-4 flex items-center gap-2" data-id="element-177" data-mp="6bootdxyiz70">
          <span aria-hidden="true" data-id="element-178" data-mp="6a3v1qjgvka7">🏆</span>
          <h3 className="font-serif-display text-2xl font-bold text-[var(--cream)]" data-id="element-179" data-mp="2b4vklgi8fq5">
            Super Kit + Estudio PRO
          </h3>
        </div>
        <p className="mb-6 text-sm text-white/60" data-id="element-180" data-mp="ytsp94vx5bqd">
          6 Tomos + 6 Bonos + Sistema de Gestión y Marketing
        </p>
        <div className="mb-6 mt-auto" data-id="element-181" data-mp="2o9mv8ls6gmvm">
          <p className="text-lg text-white/40 line-through" data-id="element-182" data-mp="2oao7gtkxjfex">$69.000</p>
          <p className="font-serif-display text-4xl font-bold text-[var(--gold-light)] sm:text-5xl" data-id="element-183" data-mp="2t8gbglyumrzh">
            $27.990 <span className="text-xl text-[var(--gold)]" data-id="element-184" data-mp="2ekd4paczfc9m">ARS</span>
          </p>
        </div>
        <CtaButton variant="gold" size={compact ? 'md' : 'lg'} data-id="element-185" data-mp="2jimvz9vl5spy">
          Quiero el Super Kit + Estudio PRO
        </CtaButton>
      </div>
    </div>;
}